import { useState } from 'react';
import { Button, Inline, PasswordInput, Stack, t, TextField } from '@kanbios/ui';
import { generateSecret } from '../../lib/seal';

/** D100: the user Caddy accepts, and the length of a drawn password. */
export const ACCESS_USER = /^[a-z][a-z0-9._-]{1,31}$/;
export const ACCESS_PASSWORD_LENGTH = 24;
export const drawAccessPassword = () => generateSecret(ACCESS_PASSWORD_LENGTH);

/**
 * D100: the user and the password of an environment out of production. The password is drawn here, in the
 * browser, and shown for copying: the platform keeps its hash only and can never give it back.
 */
export function AccessFields({ user, password, onUser, onPassword, error, idPrefix = 'access', readOnly = false }: {
  user: string;
  password: string;
  onUser: (user: string) => void;
  onPassword: (password: string) => void;
  error?: string;
  idPrefix?: string;
  /** Shown to copy only (after the installation started): neither the user nor the password change. */
  readOnly?: boolean;
}) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(password);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };
  return (
    <Stack gap={12}>
      <TextField id={`${idPrefix}-user`} label={t('access.user')} hint={readOnly ? undefined : t('access.userHint')} value={user} mono readOnly={readOnly}
        onChange={e => onUser(e.target.value.trim().toLowerCase())} error={error} />
      <PasswordInput id={`${idPrefix}-password`} label={t('access.password')} hint={t('access.passwordHint')} value={password} mono readOnly autoComplete="new-password" />
      <Inline gap={8}>
        <Button variant="secondary" size="sm" icon={copied ? 'check' : 'content_copy'} onClick={() => void copy()}>{t(copied ? 'access.copied' : 'access.copy')}</Button>
        {!readOnly && <Button variant="secondary" size="sm" icon="casino" onClick={() => { setCopied(false); onPassword(drawAccessPassword()); }}>{t('access.draw')}</Button>}
      </Inline>
    </Stack>
  );
}
